/**
 * Device token for UserDevices / ValidateDeviceToken.
 * Never treat the literal strings "null" / "undefined" (from bad setItem(null)) as valid.
 */

export function normalizeStoredDeviceToken(raw) {
  if (raw == null) return '';
  const s = String(raw).trim();
  if (!s || s === 'null' || s === 'undefined') return '';
  return s;
}

/**
 * Runs once at app entry (before React). Heals corrupt keys and aligns uuid/new_uuid with index.html rules.
 */
export function deviceTokenBootstrap() {
  if (typeof window === 'undefined' || !window.localStorage) return;

  ['uuid', 'new_uuid', 'old_uuid'].forEach((key) => {
    const v = localStorage.getItem(key);
    if (v === 'null' || v === 'undefined') {
      localStorage.removeItem(key);
    }
  });

  const uuid = normalizeStoredDeviceToken(localStorage.getItem('uuid'));
  const newUuid = normalizeStoredDeviceToken(localStorage.getItem('new_uuid'));

  if (!uuid && newUuid) {
    localStorage.setItem('uuid', newUuid);
    localStorage.removeItem('new_uuid');
    return;
  }

  if (!uuid && typeof window.DeviceUUID === 'function') {
    try {
      const fresh = normalizeStoredDeviceToken(new window.DeviceUUID().get());
      if (fresh) {
        localStorage.setItem('uuid', fresh);
      }
    } catch (e) {
      /* ignore — index.html may run same init later */
    }
  }
}

/**
 * Value for Device-Token header (never literal "null"). Prefer uuid, then new_uuid, then old_uuid, then generate.
 */
export function getDeviceTokenForHeaders() {
  if (typeof window === 'undefined' || !window.localStorage) return '';

  let t =
    normalizeStoredDeviceToken(localStorage.getItem('uuid')) ||
    normalizeStoredDeviceToken(localStorage.getItem('new_uuid')) ||
    normalizeStoredDeviceToken(localStorage.getItem('old_uuid'));

  if (t) return t;

  if (typeof window.DeviceUUID === 'function') {
    try {
      const fresh = normalizeStoredDeviceToken(new window.DeviceUUID().get());
      if (fresh) {
        if (!normalizeStoredDeviceToken(localStorage.getItem('uuid'))) {
          localStorage.setItem('uuid', fresh);
        } else {
          localStorage.setItem('new_uuid', fresh);
        }
        return fresh;
      }
    } catch (e) {
      /* ignore */
    }
  }

  return '';
}
